// 'use client'

import { ReactNode } from 'react'
import {
  // clubsPath,
  imagePath,
  // leaguesPath,
  // livePath,
  // myProfilePath,
  // loginPath,
  // myProfilePath,
  // organizationsPath,
  PartnerAtlasPath,
  rootPath
  // tournamentsPath
} from 'shared/urlHelpers'
// import { ChevronLeft, Menu as MenuIcon, Search, User } from 'react-feather'
import Link from '@/components/router/Link'
// import { SearchOverlay } from '@/components/search/SearchOverlay'
// import { useSession } from 'lib/session-client'
// import { useRouter } from 'next/router'
// import { isTabletScreen } from 'shared/domHelpers'
// import Shortcuts from './Shortcuts'
// import HBButton from '@/components/ui-other/basic/HBButton'
import { IAppConfig } from '@/data/config/types'
import NewHeaderMenuButton from './NewHeaderMenuButton'
import NewHeaderSearchField from './NewHeaderSearchField'
import NewHeaderUserInfo from './NewHeaderUserInfo'
import NewShortcuts from './NewShortcuts'
// import { useUserProfile } from 'auth/useUserProfile'

function HomeHeader({ appConfig }: { appConfig: IAppConfig }): ReactNode {
  // const { openMenu } = useMenu()
  // const router = useRouter()
  // const isHome = router.pathname === '/'
  // const isTablet = isTabletScreen()
  // const [session] = useSession()
  // const { userProfile } = useUserProfile()

  return (
    <header
      id="layout-header"
      className="pt-4 lg:pt-5 md:mb-6 bg-white/[.975] backdrop-blur-sm"
    >
      {/* TODO components */}
      <div className="container lg:!w-full lg:!px-0 !max-w-[990px] xl:!max-w-[1200px] !mb-4 block relative z-10">
        <div className="flex justify-between items-center gap-6 w-full">
          {/* left */}
          <div className="flex items-center relative shrink-0">
            <NewHeaderMenuButton />
            {/* {isTablet && !isHome ? (
              <button
                onClick={() => router.back()}
                className="group shrink-0 -ml-3 w-16 mr-3 flex items-center justify-center h-10"
              >
                <ChevronLeft className="rounded-full relative p-1 h-9 w-9 right-1 group-active:bg-bodyColor group-active:text-body" />
              </button>
            ) : ( */}
            <Link href={rootPath()} className="w-10 lg:w-12 h-auo shrink-0">
              <img
                src={imagePath('handball-net-logo-sm.svg')}
                className="w-full h-full"
                alt="Handball.net Logo"
              />
            </Link>
            {/* )} */}
            <a
              href={PartnerAtlasPath()}
              target="_blank"
              rel="noreferrer"
              className="block shrink-0"
            >
              <img
                src="/img/partners/atlas/Atlas_vertikal.webp"
                className="max-h-5 lg:max-h-7 w-auto"
                alt="Atlas Logo"
              />
            </a>
          </div>
          <NewHeaderSearchField />
          <div className="hidden lg:flex shrink-0">
            <NewHeaderUserInfo />
          </div>
        </div>
      </div>

      <NewShortcuts appConfig={appConfig} />
    </header>
  )
}

export default HomeHeader
